import withFieldValidation from '../hocs/withFieldValidation';

import { replaceSpecialChars } from 'lib/utils/generic';

interface TextInputProps {
    name: string;
    type?: string;
    placeholder?: string;
    value: string;
    onChange: (name: string, value: string) => void;
    showError: () => void;
    maxLength?: number;
    minLength?: number;
    classes?: string;
    disabled?: boolean;
    shouldReplaceSpecialCharacters?: boolean;
    maxNum?: number;
    appendIcon?: React.ReactNode;
    prependIcon?: React.ReactNode;
    charLimit?: number;
    ref?: any;
}

const TextInput = ({
    type = 'text',
    name,
    placeholder,
    classes,
    value,
    onChange,
    charLimit,
    minLength,
    maxNum,
    disabled,
    showError,
    appendIcon,
    prependIcon,
    ref,
    shouldReplaceSpecialCharacters,
}: TextInputProps) => {
    const _ref = ref ? { ref } : {};
    return (
        <div {..._ref} className={`sm-input ${disabled ? 'disabled' : ''}`}>
            {prependIcon && (
                <span className="sm-input-prepend-icon">{appendIcon}</span>
            )}
            {appendIcon && (
                <span className="sm-input-append-icon">{appendIcon}</span>
            )}
            <input
                className={classes}
                type={type}
                name={name}
                placeholder={placeholder}
                value={value || ''}
                onChange={newVal => {
                    let updatedVal = newVal.target.value;
                    if (shouldReplaceSpecialCharacters) {
                        updatedVal = replaceSpecialChars(updatedVal);
                    }
                    onChange(name, updatedVal);
                }}
                onBlur={showError}
                minLength={minLength}
                maxLength={charLimit}
                max={maxNum}
                disabled={disabled}
            />
        </div>
    );
};

export default withFieldValidation(TextInput);
